import { Icon, Popover } from 'antd'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Cell } from '../../styles/styled-common'

const Breaker = styled.div`
  display: none;
  &:nth-child(4n) {
    display: block;
    width: 100%;
    height: 1px;
  }
`
const StIcon = styled(Icon)`
  padding: 5px 4px;
`
const StCell = styled(Cell)`
  font-size: 1.5em;
  align-content: center;
`

export default props => {
  const {
    support: { email, ticket, chat, is247 },
    ...p
  } = props

  return (
    <StCell {...p} flexWrap="wrap">
      <Fragment>
        {chat && (
          <Fragment>
            <Popover content="Live Chat">
              <StIcon type="message" />
            </Popover>
            <Breaker />
          </Fragment>
        )}{' '}
        {email && (
          <Fragment>
            <Popover content="Email">
              <StIcon type="mail" />
            </Popover>
            <Breaker />
          </Fragment>
        )}{' '}
        {ticket && (
          <Fragment>
            <Popover content="Ticket System">
              <StIcon type="tag-o" />
            </Popover>
            <Breaker />
          </Fragment>
        )}{' '}
        {is247 && (
          <Fragment>
            <Popover content="24/7 Support">
              <StIcon type="clock-circle-o" />
            </Popover>
            <Breaker />
          </Fragment>
        )}{' '}
      </Fragment>
    </StCell>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/CustomerSupportCell.jsx